import { render, staticRenderFns } from "./PropertyAssignModal.vue?vue&type=template&id=228e3160"
import script from "./PropertyAssignModal.vue?vue&type=script&lang=js"
export * from "./PropertyAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports